export default __webpack_public_path__ + "static/media/ic-sort.fceb19cd.svg";